import * as React from "react";
import * as ReactDOM from "react-dom/client";
import FileManager from "@valraiso-esf/file-manager";

const parentId = "FileManager";

const createParent = () => {
  const el = document.createElement("div");
  el.id = parentId;
  document.body.appendChild(el);
  return el;
};

const findParent = () => {
  const targetSelector = `#${parentId}`;
  const target = document.querySelector(targetSelector);
  return target ?? createParent();
};

const open = ({
  apiUrl,
  configKey,
  changed,
  uploadOnly,
  width,
  height,
  extensions,
  context,
}: Props) => {
  const container = findParent();

  const close = () => {
    root.unmount();
    delete container.reactRoot;
  };

  const buildTree = (): JSX.Element => {
    return (
      <React.StrictMode>
        <FileManager
          apiUrl={apiUrl}
          configKey={configKey}
          width={width}
          height={height}
          changed={changed}
          close={close}
          uploadOnly={uploadOnly}
          extensions={extensions}
          context={context}
        />
      </React.StrictMode>
    );
  };
  // BEGIN : Attention : Hack à conserver pour éviter les multiples render de widgets dans les sites marchands
  let root: ReactDOM.Root =
    container.reactRoot ?? ReactDOM.createRoot(container);
  container.reactRoot = root;
  try {
    root.render(buildTree());
  } catch (e) {
    root = ReactDOM.createRoot(container);
    container.reactRoot = root;
    root.render(buildTree());
  }
  // END : Attention : Hack à conserver pour éviter les multiples render de widgets dans les sites marchands

  return [buildTree, container, root];
};

window.FileManager = { ...window.FileManager, open };

type Props = {
  apiUrl: string;
  configKey: string;
  changed: (result: FileManagerResult) => void;
  close: () => void;
  uploadOnly: boolean;
  width: number;
  height: number;
  extensions: string[];
  context: Record<string, any>;
};

type FileManagerResult = {
  path: string;
  bucket: string;
  contentType: string;
  extension: string;
  file: string;
  name: string;
  size: string;
  updated: Date;
  width?: number;
  height?: number;
};

declare global {
  interface Window {
    FileManager?: {
      open: typeof open;
    };
  }
  interface Element {
    reactRoot?: ReactDOM.Root;
  }
}
